import Vue from 'vue';
import {
  Button,
  Form,
  FormItem,
  Input,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Menu,
  Pagination,
  MenuItem,
  Row,
  Col,
  Tooltip,
  Dialog,
  Select,
  Option,
  Tag,
  Message,
  MessageBox,
  Progress,
  Table,
  TableColumn,
  Card,
  Badge,
  Checkbox,
  CheckboxGroup,
  Step,
  Steps,
  Scrollbar,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Carousel,
  CarouselItem,
  Popover,
  Link,
  Tabs,
  TabPane,
} from 'element-ui';

Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Menu);
Vue.use(Pagination);
Vue.use(MenuItem);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tooltip);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tag);
Vue.use(Progress);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Card);
Vue.use(Badge);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Step);
Vue.use(Steps);
Vue.use(Scrollbar);
Vue.use(Dropdown);
Vue.use(DropdownItem);
Vue.use(DropdownMenu);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Popover);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Link);

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
